export const APP_NAME = 'FPG BLOCKCHAIN E-VOTING'
export const PERSIST_STORE_NAME = 'admin'
export const USER = 'user'
export const SUPERADMIN = 'superadmin'
export const REDIRECT_URL_KEY = 'redirectUrl'
